/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
    createEntityListActions,
    createEntityListState,
    createEntityMapActions,
    createEntityMapState,
    createGenericStore,
    createSingleSelectActions,
    createSingleSelectState
} from "@microsoft/shifts-experiences-shared";

import { CrossLocationOpenShiftsActions } from "./CrossLocationOpenShiftsActions";
import { CrossLocationOpenShiftsState } from "./CrossLocationOpenShiftsState";

/**
 * The cross location open shifts store and actions.
 */
const { actions, store } = createGenericStore<CrossLocationOpenShiftsState, CrossLocationOpenShiftsActions>({
    actionsCreators: [createEntityListActions, createEntityMapActions, createSingleSelectActions],
    namespace: "CrossLocationOpenShiftsStore",
    statesCreators: [createEntityListState, createEntityMapState, createSingleSelectState]
});

/**
 * The store which holds the list of cross-location open shifts ids, a map of open shift id to entity, and the selected open shift id, if any.
 */
export const CrossLocationOpenShiftsStore = store;

/**
 * The actions for the cross-location open shifts store.
 */
export const crossLocationOpenShiftsActions = actions;
